import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const isGooglePayPaymentMethodSelected = createSelector(creditCardsState, (creditCards) => creditCards.activeCardId === OLO.Enums.PAYMENT_VENDOR_SERVICE.GOOGLE_PAY);
